import React from 'react';
import Layout from '../components/Layout';
import { TradeHistorySection } from '../components/history/TradeHistorySection';

export default function History() {
  return <Layout><div data-testid="history-container"><TradeHistorySection /></div></Layout>;
}